import { render, staticRenderFns } from "./EmployeeSwitchDropdown.vue?vue&type=template&id=4d873e09&scoped=true&"
import script from "./EmployeeSwitchDropdown.vue?vue&type=script&lang=js&"
export * from "./EmployeeSwitchDropdown.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSwitchDropdown.vue?vue&type=style&index=0&id=4d873e09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d873e09",
  null
  
)

export default component.exports